function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
  fill: "#009CA6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.4753 20.0237L33.3332 13.1876V26.9187L26.4753 20.0237ZM7.917 29.167L15.292 21.792L18.822 25.3203C19.472 25.972 20.527 25.972 21.1787 25.3203L24.707 21.792L32.0837 29.167C32.0837 29.167 31.6742 30 30.0192 30C28.3642 30 11.6185 30 10.0739 30C8.52938 30 7.917 29.167 7.917 29.167ZM6.6665 13.1772L13.5237 20.0237L6.6665 26.8678V13.1772ZM12.867 10H27.132C27.132 10 29.7155 10 30.6687 10C31.6218 10 32.1303 10.8337 32.1303 10.8337L24.707 18.2553L22.9403 20.0237L20.0003 22.9637L17.0603 20.0237L15.292 18.2553L7.86867 10.8337C7.86867 10.8337 8.4851 10 9.332 10C10.1789 10 12.867 10 12.867 10Z",
  fill: "white"
});

function SvgAppIconEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconEnvelope);
export default __webpack_public_path__ + "static/media/appIconEnvelope.cc791cf8.svg";
export { ForwardRef as ReactComponent };